/** @format */

const baseUrl = process.env.REACT_APP_API_URL;

export function getArticles() {
	return [
		{
			name: 'Personbil',
			sort: 100,
			pbe: 1,
		},
		{
			name: 'Lastebil',
			sort: 101,
			pbe: 2,
		},
		{
			name: 'Semitrailer',
			sort: 102,
			pbe: 3,
		},
	];
}

export function getStops() {
	return fetch(baseUrl + '/Stop')
		.then(handleResponse)
		.catch(handleError);
}

export function getDestinations(stopId) {
	return fetch(baseUrl + '/Stop/' + stopId + '/Destinations')
		.then(handleResponse)
		.catch(handleError);
}

export function getTravels(travelQuery) {
	return fetch(baseUrl + '/Booking/Search', {
		method: 'POST',
		dataType: 'json',
		body: JSON.stringify(travelQuery),
		headers: { 'Content-Type': 'application/json' },
	})
		.then(handleResponse)
		.catch(handleError);
}

export function createBooking(booking) {
	return fetch(baseUrl + '/Booking', {
		method: 'POST',
		dataType: 'json',
		body: JSON.stringify(booking),
		headers: { 'Content-Type': 'application/json' },
	})
		.then(handleResponse)
		.catch(handleError);
}

export function getBooking(guid) {
	return fetch(baseUrl + `/Booking?guid=${guid}`)
		.then(handleResponse)
		.catch(handleError);
}

export function isErrorResponse(response) {
	return response?.hasOwnProperty('isClientError') ?? false;
}

async function handleResponse(response) {
	if (response.ok) {
		const contentType = response.headers.get('Content-Type');
		if (contentType && contentType.includes('application/pdf')) {
			return response.blob();
		}
		return response.json();
	}
	//https://www.restapitutorial.com/httpstatuscodes.html
	const error = await response.text();
	const statusCode = parseInt(response.status);
	return handleResponseError(statusCode, error);
}

function handleResponseError(status, errorText) {
	return {
		isClientError: status >= 400 && status < 500,
		errorCode: status,
		errorMessage: errorText,
	};
}

function handleError(error) {
	return {
		isClientError: false,
		errorCode: 999,
		errorMessage: error,
	};
}

